import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { AdministrativeLeavesDashboard } from '../../../features/administrative-leaves'
import { ADMINISTRATIVE_LEAVES_COMBOS_IDS } from '../constants'
import { useCombos } from '../../../features/combos/hooks'

export const AdministrativeLeavesPage = () => {
  useCombos(ADMINISTRATIVE_LEAVES_COMBOS_IDS)

  return (
    <Routes>
      <Route exact path="" element={<AdministrativeLeavesDashboard />} />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  )
}
